import React, { useState } from 'react';
import { Button, Tooltip } from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import DataExportForm from './DataExportForm';

const ExportButton = ({ resource, filters, hiddenFilterKeys = [], type = 'primary', ghost = false, size = 'middle' }) => {
    const { t } = useTranslation();
    const [modalOpen, setModalOpen] = useState(false);

    const handleOpenModal = () => {
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
    };

    return (
        <>
            <Tooltip title={t('export_data')}>
                <Button
                    type={type}
                    ghost={ghost}
                    size={size}
                    icon={<ExportOutlined />}
                    onClick={handleOpenModal}
                >
                    {t('export')}
                </Button>
            </Tooltip>

            <DataExportForm
                open={modalOpen}
                onClose={handleCloseModal}
                initialResource={resource}
                initialFilters={filters}
                hiddenFilterKeys={hiddenFilterKeys}
            />
        </>
    );
};

export default ExportButton;
